import React from 'react'
import ContextMenuItem from './ContextMenuItem'
import { AFFICHER_DEPARTEMENT } from './contextmenu.constants'
import { useT } from '../../i18n/T'
import { useAction, withEverySelectorTruthy } from '../../utils/react-redux'
import { searchDepartmentFromPoint } from '../../../store/address/address.actions'
import { selectIsPlacesUniverse } from '../../../store/history/history.selectors'

const ContextMenuItemShowCity = () => {
  const label = useT('map.context-menu.show-department')
  const execSearchLocation = useAction(searchDepartmentFromPoint)

  return <ContextMenuItem tagAction={AFFICHER_DEPARTEMENT} label={label} clickAction={execSearchLocation} />
}

export default withEverySelectorTruthy(selectIsPlacesUniverse)(ContextMenuItemShowCity)
